import { LuSend } from "react-icons/lu";
import ChatMessage from "../../Component/chat/ChatMessage";
import { useEffect, useState, useRef } from "react";
import apiRequests from "../../Component/axios/config/config";
import { useParams } from "react-router-dom";
import Loading from "../../Component/Loading/Loading";

export default function CustomerChat() {
  const { ticketId } = useParams();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inputText, setInputText] = useState("");
  const textareaRef = useRef(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (!ticketId) return;

    const fetchMessages = async () => {
      try {
        setLoading(true);
        const response = await apiRequests.get(
          `/tickets/v1/get-ticket-messages-seller/${ticketId}`,
        );

        if (response.data.success) {
          const msgs = (response.data.data || []).map((msg) => ({
            _id: msg._id,
            description: msg.description,
            isSeller: !!msg.sender?.seller_id,
            createdAt: msg.createdAt,
            ticket_id: msg.ticket_id,
          }));

          setMessages(msgs);
          setTimeout(() => {
            scrollToBottom("auto");
          }, 0);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [ticketId]);

  const handleSend = async () => {
    if (!inputText.trim()) return;

    try {
      const res = await apiRequests.put(`/tickets/v1/seller-answer-ticket`, {
        ticket_id: ticketId,
        description: inputText.trim(),
      });

      console.log("Response:", res.data);

      const response = await apiRequests.get(
        `/tickets/v1/get-ticket-messages-seller/${ticketId}`,
      );

      if (response.data.success) {
        const msgs = (response.data.data || []).map((msg) => ({
          _id: msg._id,
          description: msg.description,
          isSeller: !!msg.sender?.seller_id,
          createdAt: msg.createdAt,
          ticket_id: msg.ticket_id,
        }));

        setMessages(msgs);
      }

      setInputText("");

      if (textareaRef.current) {
        textareaRef.current.style.height = "auto";
        textareaRef.current.style.overflowY = "hidden";
      }
    } catch (err) {
      console.error(err);
    }
  };

  const scrollToBottom = (behavior = "smooth") => {
    messagesEndRef.current?.scrollIntoView({ behavior });
  };

  return (
    <div className="flex flex-col h-[calc(100vh-80px)] w-full overflow-hidden bg-white">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="flex-1 min-h-0 overflow-y-auto p-10 flex flex-col gap-4">
            {" "}
            {messages.map((e) => (
              <ChatMessage
                key={e._id}
                text={e.description}
                time={new Date(e.createdAt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                color={e.isSeller ? "bg-[#ADD3F2]" : "bg-[#F0E1D9]"}
                isSender={e.isSeller}
              />
            ))}
          </div>

          <div className="sticky bottom-0 bg-[#F0E1D9] rounded-2xl m-4 p-3">
            <div className="p-1 flex flex-row justify-center items-center w-full border border-[#937B6C] h-full rounded-2xl bg-[#F0E1D9]">
              <textarea
                ref={textareaRef}
                placeholder="Type a message"
                rows={1}
                value={inputText}
                className="w-full p-4 rounded-lg outline-none resize-none bg-[#F0E1D9]"
                style={{ maxHeight: "72px" }}
                onChange={(e) => {
                  setInputText(e.target.value);

                  const textarea = e.target;
                  textarea.style.height = "auto";

                  const maxHeight = 72;

                  if (textarea.scrollHeight > maxHeight) {
                    textarea.style.height = `${maxHeight}px`;
                    textarea.style.overflowY = "auto";
                  } else {
                    textarea.style.height = `${textarea.scrollHeight}px`;
                    textarea.style.overflowY = "hidden";
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && e.shiftKey) {
                    return;
                  }

                  if (e.key === "Enter") {
                    e.preventDefault();

                    if (inputText.trim()) {
                      handleSend();
                    }
                  }
                }}
              />
              <button
                type="button"
                onClick={handleSend}
                className="pr-4 cursor-pointer hover:text-gray-700"
              >
                <LuSend className="text-2xl text-[#937B6C]" />
              </button>
            </div>
          </div>
        </>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
}
